import { storeToRefs } from 'pinia';
import { useUserDetailsStore } from '@/stores/useUserDetails';
import { notificationKeys } from '@/constants/notificationKeys';

export default defineNuxtRouteMiddleware(async (to) => {
  const userDetailsStore = useUserDetailsStore();

  const { userName } = storeToRefs(userDetailsStore);

  // User details is used for Mixpanel events
  if (!userName.value) {
    userDetailsStore.getUserDetails();
  }

  const recommendedJobsStore = useRecommendedJobsStore();
  const notificationsStore = useNotificationsStore();
  const { trackEvent, eventNames } = useAcvAnalytics();

  if (to.query.jobs) {
    const orderIds = to.query.jobs?.split(',');

    recommendedJobsStore.setOrderIds(orderIds);
    await recommendedJobsStore.fetchRecommendedJobs(orderIds);
    const { jobs } = storeToRefs(recommendedJobsStore);

    if (jobs.value.length === 0) {
      const notificationParams = {
        notificationMessageTemplate: `We're out of recommendations. Search our Job List for more jobs.`,
        variant: 'info',
        key: notificationKeys.noMoreRecos,
      };

      notificationsStore.addNotification(notificationParams);
      notificationsStore.setActiveNotification(notificationKeys.noMoreRecos);

      trackEvent(eventNames.REC_PAGE_URL_FALLBACK);

      return navigateTo({ path: '/' });
    }

    trackEvent(eventNames.REC_PAGE_URL_VISIT, {
      rec_order_ids: orderIds,
      rec_available_order_ids: jobs.value.map((job) =>
        job?.requestId?.toString()
      ),
    });
  }
});
